<!-- 创建固定商家券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "traderCode": "NY7GW01MPGD6",
                "groupName": "固定劵1",
                "validFrom": "2018-04-13 09:00:00",
                "validTo": "2018-04-16 09:00:00",
                "maxNum": "300",
                "sellBillId": "262720",
                "uniqNo": "545454545"
                },
            responseCode: {
                "data": {
                    "code":"212316545",
                    "qrCode":"http://asdasdasdasdasddsadad",
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台创建固定电子优惠券，适合一个二维码多张优惠券的场景。（注意：对同一个电子券模板不能与“发放电子券”、“打印电子券”混用。）",
                t_url: this.commonUrls.test+"createFixedCoupon",
                p_url: this.commonUrls.prod+"createFixedCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCode', info2: '是', info3: 'String', info4: '授权商对应的商家代号' },
                        { info1: 'groupName', info2: '是', info3: 'String', info4: '固定券名称' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效开始时间 yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '有效结束时间 yyyy-MM-dd HH:mm:ss' },
                        { info1: 'maxNum', info2: '是', info3: 'Integer', info4: '总张数' },
                        { info1: 'sellBillId', info2: '是', info3: 'Integer', info4: '销售账单ID' },
                        { info1: 'uniqNo', info2: '是', info3: 'String', info4: '唯一请求编号,保证接口等幂性' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'code', info2: '是', info3: 'String', info4: '固定券编码' },
                        { info1: 'qrCode', info2: '是', info3: 'String', info4: '二维码内容' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/createFixedCoupon.vue